import { styled } from "@mui/material/styles"

import Column from "../../../common/components/Column"

export default styled(Column)(({ theme }) => ({
  paddingInline: theme.spacing(3),
  paddingBlock: theme.spacing(3),
  [theme.breakpoints.only("xs")]: {
    padding: theme.spacing(2),
  },
}))
